import React from "react";
import styles from "./Slide3.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../Production.messages";
import { useBlocks } from "@jelly/lesson";
import config from "appConfig";

export const Slide3: React.FC = () => {
  const { formatMessage } = useIntl();
  const block = useBlocks();
  return (
    <div className={styles.root}>
      <h3>{formatMessage(messages.G6_P4_S3_Title)}</h3>
      <block.image src={`${config.STATIC_ASSETS_URL}/lms/guide/guide06/en/middleware.svg`}></block.image>
    </div>
  );
};
